import { Typography, useTheme, Chip, Box, Grid, Button } from "@mui/material";
import { CompanyDetails } from "../../../../../../types/companies-managment/Company";
import MainCard from "../../../../../../components/MainCard";

interface CompanyInformationProps {
  company: CompanyDetails;
}

const CompanyInformation: React.FC<CompanyInformationProps> = ({ company }) => {
  const theme = useTheme();

  return (
    <MainCard
      title="Company Information"
      headerActions={
        <Button color="primary" variant="contained">
          Edit profile
        </Button>
      }
    >
      <Grid container spacing={2}>
        <Grid
          item
          md={6}
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "1rem",
            gap: "1rem",
          }}
        >
          {company?.name_en && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography
                color="GrayText"
                sx={{
                  width: "40%",
                }}
              >
                English name :
              </Typography>
              <Typography
                sx={{
                  width: "60%",
                }}
              >
                {company?.name_en}
              </Typography>
            </Box>
          )}
          {company?.name_trans && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography
                color="GrayText"
                sx={{
                  width: "40%",
                }}
              >
                Arabic name :
              </Typography>
              <Typography
                sx={{
                  width: "60%",
                }}
              >
                {company?.name_trans?.ar}
              </Typography>
            </Box>
          )}

          {company?.address_en && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography
                color="GrayText"
                sx={{
                  width: "40%",
                }}
              >
                English address :
              </Typography>
              <Typography
                sx={{
                  width: "60%",
                }}
              >
                {company?.address_en}
              </Typography>
            </Box>
          )}
          {company?.address_trans && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography
                color="GrayText"
                sx={{
                  width: "40%",
                }}
              >
                Arabic address :
              </Typography>
              <Typography
                sx={{
                  width: "60%",
                }}
              >
                {company?.address_trans?.ar}
              </Typography>
            </Box>
          )}
          {company?.company_type && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography
                color="GrayText"
                sx={{
                  width: "40%",
                }}
              >
                Company type :
              </Typography>
              <Typography
                sx={{
                  width: "60%",
                }}
              >
                {company?.company_type}
              </Typography>
            </Box>
          )}
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "1rem",
            gap: "1rem",
          }}
        >
          <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
            <Typography
              color="GrayText"
              sx={{
                width: "40%",
              }}
            >
              Employees count :
            </Typography>
            <Typography
              sx={{
                width: "60%",
              }}
            >
              {company?.employees_num || "0"}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
            <Typography
              color="GrayText"
              sx={{
                width: "40%",
              }}
            >
              Expected employees count :
            </Typography>
            <Typography
              sx={{
                width: "60%",
              }}
            >
              {company?.expected_employees_num || "0"}
            </Typography>
          </Box>

          {company?.company_activities &&
            company?.company_activities.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <Typography
                  color="GrayText"
                  sx={{
                    width: "40%",
                  }}
                >
                  Company activities :
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    width: "60%",
                  }}
                >
                  {company?.company_activities?.map((activity) => (
                    <Chip
                      color="primary"
                      key={activity.id}
                      label={
                        theme.direction === "rtl"
                          ? activity?.name_trans?.ar
                          : activity?.name
                      }
                      sx={{
                        color: "#fff",
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "1rem",
            gap: "1rem",
          }}
        >
          {company?.description_en && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography
                color="GrayText"
                sx={{
                  width: "19%",
                }}
              >
                English description :
              </Typography>
              <Typography
                sx={{
                  width: "81%",
                }}
              >
                {company?.description_en}
              </Typography>
            </Box>
          )}
          {company?.description_trans && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography
                color="GrayText"
                sx={{
                  width: "19%",
                }}
              >
                Arabic description :
              </Typography>
              <Typography
                sx={{
                  width: "81%",
                }}
              >
                {company?.description_trans?.ar}
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </MainCard>
  );
};

export default CompanyInformation;
